import { FilterRow } from "@components/FilterTag/FilterTag";
import { Checkbox, LoadingSkeleton } from "@narmi/design_system";
import { $staffApi } from "../../../api";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { ThreadQuery } from "../types";

export function StaffAssigneeTag({
  filters,
  isExpanded,
  close,
  open,
  setFilters,
}: {
  filters: ThreadQuery;
  isExpanded: boolean;
  close: () => void;
  open: () => void;
  setFilters: Dispatch<SetStateAction<ThreadQuery>>;
}) {
  const { data: staffers, isLoading } = $staffApi.useQuery("get", "/api/assignments/staffers/");

  const [staffAssigneeFilters, setStaffAssigneeFilters] = useState<string[]>(
    filters.staff_assignee
  );

  useEffect(() => {
    setStaffAssigneeFilters(filters.staff_assignee);
  }, [isExpanded, filters.staff_assignee]);

  return (
    <FilterRow.Tag
      label="Staff Assignee"
      countApplied={filters.staff_assignee.length}
      isExpanded={isExpanded}
      onPopoverDismiss={() => close()}
      onToggle={() => open()}
    >
      <FilterRow.FormContainer>
        <LoadingSkeleton isLoading={!staffers || isLoading}>
          <Checkbox
            label="No assignee"
            checked={staffAssigneeFilters.includes("unassigned")}
            onChange={() => {
              const isChecked = staffAssigneeFilters.includes("unassigned");
              const newFilters = isChecked
                ? staffAssigneeFilters.filter((filter) => filter !== "unassigned")
                : [...staffAssigneeFilters, "unassigned"];
              setStaffAssigneeFilters(newFilters);
            }}
          />
          {staffers &&
            staffers.users.map((user) => (
              <Checkbox
                key={user.id}
                label={user.full_name}
                checked={staffAssigneeFilters.includes(user.id)}
                onChange={() => {
                  const isChecked = staffAssigneeFilters.includes(user.id);
                  const newFilters = isChecked
                    ? staffAssigneeFilters.filter((filter) => filter !== user.id)
                    : [...staffAssigneeFilters, user.id];

                  setStaffAssigneeFilters(newFilters);
                }}
              />
            ))}
          {staffers && !staffers.users.length ? <FilterRow.NoResultsFound /> : null}
        </LoadingSkeleton>
      </FilterRow.FormContainer>
      <FilterRow.ActionBar
        onClear={() => {
          setStaffAssigneeFilters([]);
          setFilters((prev) => ({
            ...prev,
            staff_assignee: [],
            offset: 0,
          }));
          close();
        }}
        onApply={() => {
          setFilters((prev) => ({
            ...prev,
            staff_assignee: staffAssigneeFilters,
            offset: 0,
          }));
          close();
        }}
      />
    </FilterRow.Tag>
  );
}
